import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { KYMW0003Model } from '../kymw0003.model';
import { Injectable } from '@angular/core';
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { PlanSupportCompanyInfo } from '../vo/PlanSupportCompanyInfoRow';

// レスポンス構造
type GetPlanSupportCompanyInfoResponse = {
  AssociatedCompanyId: string;
  AssociatedCompanyName: string;
  TradeStopDiv: string;
  TradeStopName: string;
}[];

/**
 * 企画支援選択サービス
 * @export GetPlanSupportCompanyInfoService
 * @class GetPlanSupportCompanyInfoService
 * @extends {PlessJsonResponderSub}
 */
@Injectable({
  providedIn: 'root'
})
export class GetPlanSupportCompanyInfoService extends PlessJsonResponderSub<GetPlanSupportCompanyInfoResponse> {
  private model: KYMW0003Model;
  private calbak: () => void;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetPlanSupportCompanyInfoService
   */
  private getBody(): PlessRequest {
    return new PlessRequest();
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof GetPlanSupportCompanyInfoService
   */
  execute(model: KYMW0003Model, f?: () => void): void {
    this.model = model;
    this.calbak = f;
    this.send('getPlanSupportCompanyInfo', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetPlanSupportCompanyInfoService
   */
  success(data: GetPlanSupportCompanyInfoResponse) {
    this.model.planSupportCompanyInfoList = data.map(_ =>
      new PlanSupportCompanyInfo(
        _.AssociatedCompanyId,
        _.AssociatedCompanyName,
        _.TradeStopDiv,
        _.TradeStopName
      )
    );
    if (this.calbak) this.calbak();
  }
}
